Monitoring.Views ||= {}

class Monitoring.Views.ReviewQueueDefinitionListView extends Backbone.View
  template: JST["backbone/templates/moderation/review_queue_definitions/review_queue_definition_list"]
  events:
    'click .edit-review_queue_definition': 'onClickEdit'
    'click .delete-review_queue_definition': 'onClickDelete'

  initialize: (@options = {}) ->
    @reviewQueueDefinitions = @options.reviewQueueDefinitions
    @availableTopics        = @options.availableTopics
    extendedTags = [
      {code: "any_tag", description: "Any Tag"},
      {code: "no_tags", description: "No Tags"}
    ]
    @availableTags          = @options.availableTags.concat(extendedTags)
    @availableGroups        = @options.availableGroups
    @availableSubtypes      = @options.allSubtypes
    @availableUsers         = @options.availableUsers
    @availableUsersGroups   = @options.availableUsersGroups

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    @trigger('edit', @reviewQueueDefinitions.get($(evt.currentTarget).data('id')))

  onClickDelete: (evt) ->
    swal({
      title: I18n.t('monitoring.review_queue_definition.confirmation.confirm')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.rules.confirmation.confirm')
      cancelButtonText: I18n.t('monitoring.rules.confirmation.cancel')
      closeOnConfirm: true
    }, =>
      definitionToDelete = @reviewQueueDefinitions.get($(evt.currentTarget).data('id'))
      definitionToDelete.destroy(
        success: (response) =>
          @reviewQueueDefinitions.remove(definitionToDelete)
          @render()
        error: (response) =>
          console.log("Error deleting definition #{definitionToDelete.get('name')}")
      )
    )

  getUser: (user) ->
    return user if user?
    I18n.t('monitoring.review_queue_definition.no_user')

  getPermissionsAsText: (reviewQueueDefinition) ->
    users = _.filter(_.map(reviewQueueDefinition.get('granted_entities').user_ids, (userId) =>
      user = _.find(@availableUsers, (user) -> user.id == userId)
      if user then "#{user.first_name} #{user.last_name}" else null
    ), (str) -> str).join(', ')

    usersGroups = _.filter(_.map(reviewQueueDefinition.get('granted_entities').users_group_ids, (groupId) =>
      _.find(@availableUsersGroups, (group) -> group.id == groupId)?.name
    ), (str) -> str).join(', ')

    text = ''
    text += "<b>#{I18n.t('monitoring.review_queue_definition.list.users')}</b>: <br> #{users}" if users.length > 0
    if usersGroups.length > 0
      text += '<br>' if users.length > 0
      text += "<b>#{I18n.t('monitoring.review_queue_definition.list.groups')}</b>: <br> #{usersGroups}"
    text

    # TODO Refactor: Hacer modelo social_content_conditions.js
  getConditionsAsText: (rule) ->
    _.filter([
      @getTopicsString(rule),
      @getIncludedTagsString(rule),
      @getExcludedTagsString(rule),
      @getIncludedGroupsString(rule),
      @getExcludedGroupsString(rule),
      @getSubtypesString(rule),
      @getOwnershipString(rule),
      @getAuthorsString(rule),
      @getExcludedAuthorsString(rule),
      @getLocationsString(rule),
      @getMentionsString(rule),
      @getMinFollowersString(rule),
      @getNewsSourcesString(rule),
      @getSentimentsString(rule),
      @getModerationStatusString(rule),
      @getKeywordsString(rule)
    ], (str) -> str != "").join('<br>')

  getKeywordsString: (rule) ->
    # TODO: This is to avoid conflicts when doing a cherry-pick. Delete this method when the real 'getKeywordsString' exists
    return ''

  getTopicsString: (rule) ->
    if rule.get('social_content_condition').topics.length > 0
      topicNames = _.map(rule.get('social_content_condition').topics, (id) =>
        _.find(@availableTopics, (topic) -> topic.id == parseInt(id))?.name
      )
      "<b>#{I18n.t('monitoring.rules.fields.topics')}</b>: #{topicNames.join(', ')}"
    else
      ""

  getIncludedTagsString: (rule) ->
    @includedTagsStringFor(rule.get('social_content_condition'))

  includedTagsStringFor: (conditions) ->
    filter = conditions.intelligent_filter.intelligent_tags
    tags = (filter.main_tags || []).concat((filter.secondary_tags || []))
    @tagsString(tags, 'monitoring.rules.fields.tags.included')

  getExcludedTagsString: (rule) ->
    @excludedTagsStringFor(rule.get('social_content_condition'))

  excludedTagsStringFor: (conditions) ->
    tags = conditions.intelligent_filter.intelligent_tags.excluded_tags || []
    @tagsString(tags, 'monitoring.rules.fields.tags.excluded')

  tagsString: (tagIds, translation) ->
    if tagIds.length > 0
      tagDescriptions = _.map(_.uniq(tagIds), (tagId) =>
        matchingTag = _.find(@availableTags, (tag) -> tag.code.toString() == tagId.toString())
        "'#{if matchingTag then matchingTag.description else tagId}'"
      )

      "#{I18n.t(translation)}: #{tagDescriptions.join(', ')}"
    else
      ''

  getIncludedGroupsString: (rule) ->
    @includedGroupsStringFor(rule.get('social_content_condition'))

  includedGroupsStringFor: (conditions) ->
    filter = conditions.intelligent_filter.intelligent_groups
    groupIds = (filter.main_groups || []).concat((filter.secondary_groups || []))
    @groupsString(groupIds, 'monitoring.rules.fields.groups.included')

  getExcludedGroupsString: (rule) ->
    @excludedGroupsStringFor(rule.get('social_content_condition'))

  excludedGroupsStringFor: (conditions) ->
    groupIds = conditions.intelligent_filter.intelligent_groups.excluded_groups || []
    @groupsString(groupIds, 'monitoring.rules.fields.groups.excluded')

  groupsString: (groupIds, translation) ->
    if groupIds.length > 0
      groupDescriptions = _.map(_.uniq(groupIds), (groupId) =>
        matchingGroup = _.find(@availableGroups, (group) -> group.code.toString() == groupId.toString())
        "'#{if matchingGroup then matchingGroup.description else groupId}'"
      )

      "#{I18n.t(translation)}: #{groupDescriptions.join(', ')}"
    else
      ''

  getSentimentsString: (rule) ->
    rule_sentiments = rule.get('social_content_condition').sentiments
    if rule_sentiments.length > 0
      translated_rule_sentiments = _.map(rule_sentiments, (s) ->
        I18n.t('monitoring.rules.sentiments.' + s)
      )
      "<b>#{I18n.t('monitoring.rules.fields.sentiments')}</b>: #{translated_rule_sentiments.join(', ')}"
    else
      ""

  getSubtypesString: (rule) ->
    if rule.get('social_content_condition').subtypes.length > 0
      subtypeNames = _.map(rule.get('social_content_condition').subtypes, (code) =>
        _.find(@availableSubtypes, (subtype) -> subtype.code == code)?.name
      )
      "<b>#{I18n.t('monitoring.rules.fields.types')}</b>: #{subtypeNames.join(', ')}"
    else
      ""

  getModerationStatusString: (rule) ->
    moderation_statuses = rule.get('social_content_condition').moderation_statuses
    if moderation_statuses.length > 0
      translated_moderation_statuses = _.map(moderation_statuses, (s) ->
        I18n.t('monitoring.rules.fields.' + s)
      )
      "<b>#{I18n.t('monitoring.rules.fields.moderation')}</b>: #{translated_moderation_statuses.join(', ')}"
    else
      ""

  getOwnershipString: (rule) ->
    if rule.get('social_content_condition').ownership == 'own-content'
      I18n.t('monitoring.rules.fields.only_own_content')
    else if rule.get('social_content_condition').ownership == 'not-own-content'
      I18n.t('monitoring.rules.fields.exclude_own_content')
    else
      ""

  getAuthorsString: (rule) ->
    if rule.get('social_content_condition').authors.length > 0
      "<b>#{I18n.t('monitoring.rules.fields.authors')}</b>: #{rule.get('social_content_condition').authors.join(', ')}"
    else
      ""

  getExcludedAuthorsString: (rule) ->
    if rule.get('social_content_condition').excluded_authors.length > 0
      "<b>#{I18n.t('monitoring.rules.fields.excluded_authors')}</b>: #{rule.get('social_content_condition').excluded_authors.join(', ')}"
    else
      ""

  getLocationsString: (rule) ->
    if rule.get('social_content_condition').locations.length > 0
      "<b>#{I18n.t('monitoring.rules.fields.locations')}</b>: #{rule.get('social_content_condition').locations.join(', ')}"
    else
      ""

  getMentionsString: (rule) ->
    if rule.get('social_content_condition').mentions.length > 0
      "<b>#{I18n.t('monitoring.rules.fields.mentions')}</b>: #{rule.get('social_content_condition').mentions.join(', ')}"
    else
      ""

  getMinFollowersString: (rule) ->
    if rule.get('social_content_condition').min_followers
      "<b>#{I18n.t('monitoring.rules.fields.minimum_followers')}</b>: #{rule.get('social_content_condition').min_followers}"
    else
      ""

  getNewsSourcesString: (rule) ->
    if rule.get('social_content_condition').news_sources.length > 0
      "<b>#{I18n.t('monitoring.rules.fields.news_sources')}</b>: #{rule.get('social_content_condition').news_sources.join(', ')}"
    else
      ""
# TODO Refactor al modelo

